// src/mixins/mobileTableMixin.js
export const mobileTableMixin = {
  data: () => ({
    isMobileDevice: false,
    fab: false,
    selectedRowIndex: null,
    detailDialog: false,
    selectedItem: null,
  }),
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      // 800 là breakpoint bạn đang dùng trong v-data-table
      this.isMobileDevice = window.innerWidth <= 800;
    },
    onScroll(e) {
      if (typeof window === 'undefined') return;
      const top = window.pageYOffset || document.documentElement.scrollTop || 0;
      // Chỉ cập nhật biến fab khi trạng thái thực sự thay đổi
      this.fab = top > 100;
    //   if (this.fab !== (top > 100)) {
    //     this.fab = top > 100;
    //   }
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    showDetail(item) {
      this.selectedItem = item;
      this.detailDialog = true;
    },
    // Hàm kiểm tra xem một field có phải là hình ảnh không
    isImageField(key) {
      const imageFields = ['imagePath', 'grooveImg', 'jointImage']; // Danh sách các key chứa ảnh
      return imageFields.includes(key);
    }
  }
}